import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var TwitterIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M7.919 20.88c8.302 0 12.842-6.878 12.842-12.843 0-.195-.004-.39-.013-.583A9.183 9.183 0 0023 5.117c-.809.359-1.68.601-2.592.71a4.53 4.53 0 001.985-2.497 9.047 9.047 0 01-2.866 1.096 4.514 4.514 0 00-7.692 4.116A12.815 12.815 0 012.53 3.827a4.497 4.497 0 00-.611 2.268 4.51 4.51 0 002.008 3.757 4.48 4.48 0 01-2.044-.564v.057a4.516 4.516 0 003.62 4.425 4.528 4.528 0 01-2.038.078 4.518 4.518 0 004.217 3.135 9.057 9.057 0 01-5.606 1.932c-.364 0-.724-.021-1.077-.063a12.778 12.778 0 006.919 2.027",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
TwitterIcon.isCarinaIcon = true;
export default TwitterIcon;
